module.exports = __webpack_public_path__ + "static/media/pumpkins-sm.73a6106c.gif";